import Vue from 'vue';
import clampy from '@clampy-js/vue-clampy';

Vue.use(clampy);
